/* Petunio — comportamiento de la landing. Sin dependencias. */
(function () {
  'use strict';

  var EVENT_PACK = 'petunio:pack';

  /* ---------- Scroll suave a los packs ---------- */
  function initScrollLinks(root) {
    root.querySelectorAll('[data-pt-scroll]').forEach(function (el) {
      if (el.dataset.ptScrollReady) return;
      el.dataset.ptScrollReady = '1';
      el.addEventListener('click', function (e) {
        var sel = el.getAttribute('data-pt-scroll');
        var target = sel && document.querySelector(sel);
        if (!target) return; // deja que el enlace navegue normalmente
        e.preventDefault();
        var offset = 70;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        var focusable = target.querySelector('input, button, a');
        if (focusable) window.setTimeout(function () { focusable.focus({ preventScroll: true }); }, 450);
      });
    });
  }

  /* ---------- Galería del producto ---------- */
  function initGalleries(root) {
    root.querySelectorAll('[data-pt-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ptReady) return;
      gallery.dataset.ptReady = '1';
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-pt-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pt-thumb]'));
      if (slides.length < 2) return;
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.hidden = j !== i; });
          thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- Selector de packs + carrito ---------- */
  function initPacks(root) {
    root.querySelectorAll('[data-pt-packs]').forEach(function (box) {
      if (box.dataset.ptReady) return;
      box.dataset.ptReady = '1';

      var inputs = Array.prototype.slice.call(box.querySelectorAll('input[type="radio"][data-pt-pack]'));
      var idField = box.querySelector('[data-pt-field-id]');
      var qtyField = box.querySelector('[data-pt-field-qty]');
      var submit = box.querySelector('[data-pt-submit]');
      var ctaTpl = submit ? submit.getAttribute('data-pt-cta-template') || '' : '';

      function apply(input) {
        if (!input) return;
        var d = input.dataset;
        if (idField) idField.value = d.variantId || '';
        if (qtyField) qtyField.value = d.quantity || '1';
        if (submit) {
          var disponible = d.available === 'true';
          submit.disabled = !disponible || !d.variantId;
          if (ctaTpl && disponible) {
            submit.textContent = ctaTpl
              .replace('[nombre]', d.name || '')
              .replace('[precio]', d.price || '');
          } else if (!disponible) {
            submit.textContent = submit.getAttribute('data-pt-soldout') || 'Agotado';
          }
        }
        document.dispatchEvent(new CustomEvent(EVENT_PACK, {
          detail: { price: d.price || '', name: d.name || '', available: d.available === 'true' }
        }));
      }

      inputs.forEach(function (input) {
        input.addEventListener('change', function () { apply(input); });
      });

      var checked = inputs.filter(function (i) { return i.checked; })[0] || inputs[0];
      if (checked) { checked.checked = true; apply(checked); }
    });
  }

  /* ---------- Barra fija móvil ---------- */
  function initBar(root) {
    root.querySelectorAll('[data-pt-bar]').forEach(function (bar) {
      if (bar.dataset.ptReady) return;
      bar.dataset.ptReady = '1';

      var priceEl = bar.querySelector('[data-pt-bar-price]');
      var threshold = parseInt(bar.getAttribute('data-pt-threshold'), 10) || 620;
      var visible = false;

      function update() {
        var should = window.scrollY > threshold && window.innerWidth < 768;
        if (should !== visible) {
          visible = should;
          bar.setAttribute('data-visible', should ? 'true' : 'false');
        }
      }

      document.addEventListener(EVENT_PACK, function (e) {
        if (priceEl && e.detail && e.detail.price) priceEl.textContent = e.detail.price;
      });

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Menú móvil del header ---------- */
  function initDrawer(root) {
    root.querySelectorAll('[data-pt-drawer-toggle]').forEach(function (btn) {
      if (btn.dataset.ptReady) return;
      btn.dataset.ptReady = '1';
      var drawer = document.querySelector(btn.getAttribute('data-pt-drawer-toggle'));
      if (!drawer) return;
      btn.addEventListener('click', function () {
        var open = drawer.getAttribute('data-open') === 'true';
        drawer.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function init(root) {
    var scope = root || document;
    initScrollLinks(scope);
    initGalleries(scope);
    initPacks(scope);
    initBar(scope);
    initDrawer(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Re-inicializa al editar secciones en el personalizador de temas */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();